var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 141.25c9.08 0 16.5-7.43 16.5-16.5 0-9.08-7.42-16.5-16.5-16.5s-16.5 7.42-16.5 16.5c0 9.07 7.42 16.5 16.5 16.5ZM150.5 67h-8.25V50.5A41.27 41.27 0 0 0 101 9.25 41.27 41.27 0 0 0 59.75 50.5h15.67A25.6 25.6 0 0 1 101 24.93a25.6 25.6 0 0 1 25.58 25.57V67H51.5C42.42 67 35 74.42 35 83.5V166c0 9.07 7.42 16.5 16.5 16.5h99c9.07 0 16.5-7.43 16.5-16.5V83.5c0-9.08-7.43-16.5-16.5-16.5Zm0 99h-99V83.5h99V166Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "assets/media/lock-open.7298abcd.svg";
export { ForwardRef as ReactComponent };